import { PageLayout } from "../../components/common/layout/pageLayout";
import { WelcomeHeader } from "../../components/dashboard/welcomeHeader";
import { QuickLinksGrid } from "../../components/dashboard/quickLinksGrid";
import { ActivityTipsCard } from "../../components/dashboard/activityTipsCard";
import { ModuleStatusCard } from "../../components/dashboard/moduleStatusCard";
import { GettingStartedCard } from "../../components/dashboard/gettingStartedCard";
import { useDashboardData } from "../../hooks/dashboard/useDashboardData";

export const DashboardHomePage = () => {
  const { role, gymName, email, isManagerRole, modulesSettings, isLoadingGym } =
    useDashboardData();

  return (
    <PageLayout pageTitle="Dashboard">
      <WelcomeHeader gymName={gymName} email={email} />

      <QuickLinksGrid
        role={role}
        modulesSettings={modulesSettings}
        isLoading={isLoadingGym}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-compact">
        <ActivityTipsCard />
        <ModuleStatusCard modulesSettings={modulesSettings} role={role} />
      </div>

      {isManagerRole && <GettingStartedCard />}
    </PageLayout>
  );
};
